module.exports = __webpack_public_path__ + "static/media/04_tn.4ff40b3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/04_tn.jpg
// module id = 640
// module chunks = 0